import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => {
    return {
        root: {
            background: theme.palette.background.paper,
            border: `1px solid ${theme.palette.grey[300]}`,
            height: "auto",
            width: "100%",
            borderRadius: theme.spacing(1.5),
            marginTop: theme.spacing(3)
        },
        chartContainer: {
            height: "320px",
            width: "100%"
        },
        footerView: {
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            gridGap: theme.spacing(3),
            padding: theme.spacing(3, 5)
        },
        dialogContent: {
            display: "flex",
            flexWrap: "wrap",
            gridGap: theme.spacing(2),
            marginBottom: theme.spacing(2)
        }
    };
});
